module.exports = "https://bin.bnbstatic.com/_next/static/images/build-f2f5d64e22b1d1c75a934a7c74debbb8.svg";